import { SlideFrame } from '../SlideFrame';

// Banner + alt text both interpolate `universe` (threaded from page.tsx via
// /api/model-stats) so the count never drifts from the visualizer screenshot
// in the image — single source of truth, no hardcoded number.
export function Slide11OpportunityZone({ universe }: { universe: number; factorCount?: number }) {
  const count = universe.toLocaleString();
  return (
    <SlideFrame pageNum={6} title="THE VISUALIZER"
      banner={`${count} companies ranked by quality and valuation.`}>
      <div className="h-full flex items-center justify-center overflow-hidden">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src="/visualizer-screenshot.png"
          alt={`Triumph Visualizer — 3D scatter of ${count} companies plotted by quality and valuation, with the Alpha Zone ellipsoid surfacing the top 10.`}
          className="max-w-full max-h-full object-contain"
        />
      </div>
    </SlideFrame>
  );
}
